<div class="f-v"><onboarding--task-list class="m-rx3" v-model="event.tasks" taskListType="onboarding_preset_event"></onboarding--task-list></div>